@if (!loadingError) {
  <div id="title--container">
    <h4>Edit Calibration</h4>
    <h5>{{ laboratory?.laboratoryName }}</h5>
  </div>
  <hr aria-hidden="true" />
  @if (displayForm) {
    <div id="edit-calibration--container">
      <div class="card">
        <div class="header">
          <div class="card-title">Edit Calibration</div>
        </div>
        <hr class="card-divider" aria-hidden="true" />
        <div class="content">
          <div id="name-field--container">
            <app-underlined-form-field
              [parentForm]="editCalibrationForm"
              [field]="calibrationNameField"
            ></app-underlined-form-field>
          </div>
          @if (calibrationModuleType === ModuleEnum.Oxygen) {
            <div id="nav--container">
              <app-alt-option-tab-toggle
                id="oxygen-toggle--container"
                groupName="navigationToggle"
                [selectOptions]="navOptions"
                type="round"
                [(currentValue)]="selectedTabOption"
              >
              </app-alt-option-tab-toggle>
            </div>
          }
          <h6>Flask A</h6>
          <div class="form-fields">
            @if (calibrationModuleType === ModuleEnum.BaseModule) {
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="offsetAField"
                [minValue]="odOffsetMin"
                [maxValue]="odOffsetMax"
                [step]="odOffsetStep"
                [showWarning]="odForm.offsetA.value < odBelowRangeWarning"
                [warningMessage]="odBelowRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="factorAField"
                [minValue]="odFactorMin"
                [maxValue]="odFactorMax"
                [step]="odFactorStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="powerAField"
                [minValue]="odPowerMin"
                [maxValue]="odPowerMax"
                [step]="odPowerStep"
                [showWarning]="odForm.powerA.value > odPowerAboveRangeWarning"
                [warningMessage]="odPowerAboveRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="temperatureAField"
                [minValue]="odTemperatureMin"
                [maxValue]="odTemperatureMax"
                [step]="odTemperatureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "100"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi100AField"
                [minValue]="oxygenDphi100Min"
                [maxValue]="oxygenDphi100Max"
                [step]="oxygenDphi100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature100AField"
                [minValue]="oxygenTemp100Min"
                [maxValue]="oxygenTemp100Max"
                [step]="oxygenTemp100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="pressure100AField"
                [minValue]="oxygenPressureMin"
                [maxValue]="oxygenPressureMax"
                [step]="oxygenPressureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "0"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi0AField"
                [minValue]="oxygenDphi0Min"
                [maxValue]="oxygenDphi0Max"
                [step]="oxygenDphi0Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature0AField"
                [minValue]="oxygenTemp0Min"
                [maxValue]="oxygenTemp0Max"
                [step]="oxygenTemp0Step"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.pH) {
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phSlopeAField"
                [minValue]="phSlopeMin"
                [maxValue]="phSlopeMax"
                [step]="phSlopeStep"
                [showWarning]="
                  pHForm.slopeA.value < phSlopeBelowRangeWarning ||
                  pHForm.slopeA.value > phSlopeAboveRangeWarning
                "
                [warningMessage]="phSlopeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phOffsetAField"
                [minValue]="phOffsetMin"
                [maxValue]="phOffsetMax"
                [step]="phOffsetStep"
                [showWarning]="pHForm.offsetA.value < phBelowRangeWarning"
                [warningMessage]="phBelowRangeWarningMessage"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.Sparging) {
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="spargingSlopeAField"
                [minValue]="spargingSlopeMin"
                [maxValue]="spargingSlopeMax"
                [step]="spargingSlopeStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="interceptAField"
                [minValue]="spargingInterceptMin"
                [maxValue]="spargingInterceptMax"
                [step]="spargingInterceptStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.BaseModule ||
              calibrationModuleType === ModuleEnum.pH ||
              calibrationModuleType === ModuleEnum.Sparging
            ) {
              <app-number-form-field
                [parentForm]="r2Form"
                [field]="r2AField"
                [minValue]="r2Min"
                [maxValue]="r2Max"
                [step]="r2Step"
              ></app-number-form-field>
            }
          </div>
          <h6>Flask B</h6>
          <div class="form-fields">
            @if (calibrationModuleType === ModuleEnum.BaseModule) {
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="offsetBField"
                [minValue]="odOffsetMin"
                [maxValue]="odOffsetMax"
                [step]="odOffsetStep"
                [showWarning]="odForm.offsetB.value < odBelowRangeWarning"
                [warningMessage]="odBelowRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="factorBField"
                [minValue]="odFactorMin"
                [maxValue]="odFactorMax"
                [step]="odFactorStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="powerBField"
                [minValue]="odPowerMin"
                [maxValue]="odPowerMax"
                [step]="odPowerStep"
                [showWarning]="odForm.powerB.value > odPowerAboveRangeWarning"
                [warningMessage]="odPowerAboveRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="temperatureBField"
                [minValue]="odTemperatureMin"
                [maxValue]="odTemperatureMax"
                [step]="odTemperatureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "100"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi100BField"
                [minValue]="oxygenDphi100Min"
                [maxValue]="oxygenDphi100Max"
                [step]="oxygenDphi100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature100BField"
                [minValue]="oxygenTemp100Min"
                [maxValue]="oxygenTemp100Max"
                [step]="oxygenTemp100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="pressure100BField"
                [minValue]="oxygenPressureMin"
                [maxValue]="oxygenPressureMax"
                [step]="oxygenPressureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "0"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi0BField"
                [minValue]="oxygenDphi0Min"
                [maxValue]="oxygenDphi0Max"
                [step]="oxygenDphi0Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature0BField"
                [minValue]="oxygenTemp0Min"
                [maxValue]="oxygenTemp0Max"
                [step]="oxygenTemp0Step"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.pH) {
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phSlopeBField"
                [minValue]="phSlopeMin"
                [maxValue]="phSlopeMax"
                [step]="phSlopeStep"
                [showWarning]="
                  pHForm.slopeB.value < phSlopeBelowRangeWarning ||
                  pHForm.slopeB.value > phSlopeAboveRangeWarning
                "
                [warningMessage]="phSlopeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phOffsetBField"
                [minValue]="phOffsetMin"
                [maxValue]="phOffsetMax"
                [step]="phOffsetStep"
                [showWarning]="pHForm.offsetB.value < phBelowRangeWarning"
                [warningMessage]="phBelowRangeWarningMessage"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.Sparging) {
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="spargingSlopeBField"
                [minValue]="spargingSlopeMin"
                [maxValue]="spargingSlopeMax"
                [step]="spargingSlopeStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="interceptBField"
                [minValue]="spargingInterceptMin"
                [maxValue]="spargingInterceptMax"
                [step]="spargingInterceptStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.BaseModule ||
              calibrationModuleType === ModuleEnum.pH ||
              calibrationModuleType === ModuleEnum.Sparging
            ) {
              <app-number-form-field
                [parentForm]="r2Form"
                [field]="r2BField"
                [minValue]="r2Min"
                [maxValue]="r2Max"
                [step]="r2Step"
              ></app-number-form-field>
            }
          </div>
          <h6>Flask C</h6>
          <div class="form-fields">
            @if (calibrationModuleType === ModuleEnum.BaseModule) {
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="offsetCField"
                [minValue]="odOffsetMin"
                [maxValue]="odOffsetMax"
                [step]="odOffsetStep"
                [showWarning]="odForm.offsetC.value < odBelowRangeWarning"
                [warningMessage]="odBelowRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="factorCField"
                [minValue]="odFactorMin"
                [maxValue]="odFactorMax"
                [step]="odFactorStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="powerCField"
                [minValue]="odPowerMin"
                [maxValue]="odPowerMax"
                [step]="odPowerStep"
                [showWarning]="odForm.powerC.value > odPowerAboveRangeWarning"
                [warningMessage]="odPowerAboveRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="temperatureCField"
                [minValue]="odTemperatureMin"
                [maxValue]="odTemperatureMax"
                [step]="odTemperatureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "100"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi100CField"
                [minValue]="oxygenDphi100Min"
                [maxValue]="oxygenDphi100Max"
                [step]="oxygenDphi100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature100CField"
                [minValue]="oxygenTemp100Min"
                [maxValue]="oxygenTemp100Max"
                [step]="oxygenTemp100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="pressure100CField"
                [minValue]="oxygenPressureMin"
                [maxValue]="oxygenPressureMax"
                [step]="oxygenPressureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "0"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi0CField"
                [minValue]="oxygenDphi0Min"
                [maxValue]="oxygenDphi0Max"
                [step]="oxygenDphi0Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature0CField"
                [minValue]="oxygenTemp0Min"
                [maxValue]="oxygenTemp0Max"
                [step]="oxygenTemp0Step"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.pH) {
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phSlopeCField"
                [minValue]="phSlopeMin"
                [maxValue]="phSlopeMax"
                [step]="phSlopeStep"
                [showWarning]="
                  pHForm.slopeC.value < phSlopeBelowRangeWarning ||
                  pHForm.slopeC.value > phSlopeAboveRangeWarning
                "
                [warningMessage]="phSlopeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phOffsetCField"
                [minValue]="phOffsetMin"
                [maxValue]="phOffsetMax"
                [step]="phOffsetStep"
                [showWarning]="pHForm.offsetC.value < phBelowRangeWarning"
                [warningMessage]="phBelowRangeWarningMessage"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.Sparging) {
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="spargingSlopeCField"
                [minValue]="spargingSlopeMin"
                [maxValue]="spargingSlopeMax"
                [step]="spargingSlopeStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="interceptCField"
                [minValue]="spargingInterceptMin"
                [maxValue]="spargingInterceptMax"
                [step]="spargingInterceptStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.BaseModule ||
              calibrationModuleType === ModuleEnum.pH ||
              calibrationModuleType === ModuleEnum.Sparging
            ) {
              <app-number-form-field
                [parentForm]="r2Form"
                [field]="r2CField"
                [minValue]="r2Min"
                [maxValue]="r2Max"
                [step]="r2Step"
              ></app-number-form-field>
            }
          </div>
          <h6>Flask D</h6>
          <div class="form-fields">
            @if (calibrationModuleType === ModuleEnum.BaseModule) {
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="offsetDField"
                [minValue]="odOffsetMin"
                [maxValue]="odOffsetMax"
                [step]="odOffsetStep"
                [showWarning]="odForm.offsetD.value < odBelowRangeWarning"
                [warningMessage]="odBelowRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="factorDField"
                [minValue]="odFactorMin"
                [maxValue]="odFactorMax"
                [step]="odFactorStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="powerDField"
                [minValue]="odPowerMin"
                [maxValue]="odPowerMax"
                [step]="odPowerStep"
                [showWarning]="odForm.powerD.value > odPowerAboveRangeWarning"
                [warningMessage]="odPowerAboveRangeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="odCalibrationForm"
                [field]="temperatureDField"
                [minValue]="odTemperatureMin"
                [maxValue]="odTemperatureMax"
                [step]="odTemperatureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "100"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi100DField"
                [minValue]="oxygenDphi100Min"
                [maxValue]="oxygenDphi100Max"
                [step]="oxygenDphi100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature100DField"
                [minValue]="oxygenTemp100Min"
                [maxValue]="oxygenTemp100Max"
                [step]="oxygenTemp100Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="pressure100DField"
                [minValue]="oxygenPressureMin"
                [maxValue]="oxygenPressureMax"
                [step]="oxygenPressureStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.Oxygen &&
              selectedTabOption === "0"
            ) {
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="dphi0DField"
                [minValue]="oxygenDphi0Min"
                [maxValue]="oxygenDphi0Max"
                [step]="oxygenDphi0Step"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="oxygenCalibrationForm"
                [field]="temperature0DField"
                [minValue]="oxygenTemp0Min"
                [maxValue]="oxygenTemp0Max"
                [step]="oxygenTemp0Step"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.pH) {
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phSlopeDField"
                [minValue]="phSlopeMin"
                [maxValue]="phSlopeMax"
                [step]="phSlopeStep"
                [showWarning]="
                  pHForm.slopeD.value < phSlopeBelowRangeWarning ||
                  pHForm.slopeD.value > phSlopeAboveRangeWarning
                "
                [warningMessage]="phSlopeWarningMessage"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="phCalibrationForm"
                [field]="phOffsetDField"
                [minValue]="phOffsetMin"
                [maxValue]="phOffsetMax"
                [step]="phOffsetStep"
                [showWarning]="pHForm.offsetD.value < phBelowRangeWarning"
                [warningMessage]="phBelowRangeWarningMessage"
              ></app-number-form-field>
            }
            @if (calibrationModuleType === ModuleEnum.Sparging) {
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="spargingSlopeDField"
                [minValue]="spargingSlopeMin"
                [maxValue]="spargingSlopeMax"
                [step]="spargingSlopeStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="spargingCalibrationForm"
                [field]="interceptDField"
                [minValue]="spargingInterceptMin"
                [maxValue]="spargingInterceptMax"
                [step]="spargingInterceptStep"
              ></app-number-form-field>
            }
            @if (
              calibrationModuleType === ModuleEnum.BaseModule ||
              calibrationModuleType === ModuleEnum.pH ||
              calibrationModuleType === ModuleEnum.Sparging
            ) {
              <app-number-form-field
                [parentForm]="r2Form"
                [field]="r2DField"
                [minValue]="r2Min"
                [maxValue]="r2Max"
                [step]="r2Step"
              ></app-number-form-field>
            }
          </div>
          <div id="notes--container">
            <h6>Notes</h6>
            <app-underlined-textarea-field
              [parentForm]="editCalibrationForm"
              [field]="noteField"
              [minLength]="notesMinLength"
              [maxLength]="notesMaxLength"
              [rows]="4"
              [showCharacterCounter]="true"
            >
            </app-underlined-textarea-field>
          </div>
        </div>
      </div>
      <div id="button--container">
        <app-button
          label="reset"
          buttonId="reset-btn"
          buttonStyle="yellow"
          [isDisabled]="isProcessing"
          (buttonClicked)="resetForm()"
        ></app-button>
        @if (calibrationModuleType === ModuleEnum.BaseModule) {
          <app-button
            label="continue"
            buttonId="continue-btn"
            [isProcessing]="isProcessing"
            [isDisabled]="
              !(currentUser.role
                | roleCheck: editAccessRoles) ||
              editCalibrationForm.invalid ||
              odCalibrationForm.invalid ||
              r2Form.invalid
            "
            (buttonClicked)="onSubmitUpdateCalibrationForm()"
          ></app-button>
        }
        @if (calibrationModuleType === ModuleEnum.Oxygen) {
          <app-button
            label="continue"
            buttonId="continue-btn"
            [isProcessing]="isProcessing"
            [isDisabled]="
              !(currentUser.role
                | roleCheck: editAccessRoles) ||
              editCalibrationForm.invalid ||
              oxygenCalibrationForm.invalid
            "
            (buttonClicked)="onSubmitUpdateCalibrationForm()"
          ></app-button>
        }
        @if (calibrationModuleType === ModuleEnum.pH) {
          <app-button
            label="continue"
            buttonId="continue-btn"
            [isProcessing]="isProcessing"
            [isDisabled]="
              !(currentUser.role
                | roleCheck: editAccessRoles) ||
              editCalibrationForm.invalid ||
              phCalibrationForm.invalid ||
              r2Form.invalid
            "
            (buttonClicked)="onSubmitUpdateCalibrationForm()"
          ></app-button>
        }
        @if (calibrationModuleType === ModuleEnum.Sparging) {
          <app-button
            label="continue"
            buttonId="continue-btn"
            [isProcessing]="isProcessing"
            [isDisabled]="
              !(currentUser.role
                | roleCheck: editAccessRoles) ||
              editCalibrationForm.invalid ||
              spargingCalibrationForm.invalid ||
              r2Form.invalid
            "
            (buttonClicked)="onSubmitUpdateCalibrationForm()"
          ></app-button>
        }
      </div>
    </div>
  }
} @else {
  <app-error-page
    title="Error"
    primaryText="Please return to the calibration page and try again."
  ></app-error-page>
}
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="calibration-update-success"
  modalStyle="success"
  titleText="Success"
  buttonLayout="double-button"
  primaryText="Calibration updated."
  primaryButtonText="View Calibration"
  primaryButtonId="view-calibration"
  secondaryButtonText="Close"
  secondaryButtonId="close-success-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
